module.exports = __webpack_public_path__ + "img/bg2.dd618216.jpg";